<template>
  <div :class="{ show: show }" class="loading-screen">
    <span class="loader"></span>
  </div>
</template>
<script>
export default {
  name: "LoadingScreen",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.loading-screen.show {
  display: flex;
  /* animation: fade .15s linear; */
}

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.5);

  display: none;
  align-items: center;
  justify-content: center;

  /* transition: height 4s; */
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>